import axios from "axios";

const BASE_URL =
    process.env.REACT_APP_API_URL;

// ================= GET SUPER ADMIN PROFILE =================
export const getSuperAdminProfileAPI =
    async () => {
        try {
            const token =
                localStorage.getItem(
                    "authToken"
                );

            if (!token) {
                throw new Error(
                    "No auth token found"
                );
            }

            const response =
                await axios.get(
                    `${BASE_URL}/food/api/super-admin-profile/1`,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`,
                        },
                    }
                );

            return response.data;

        } catch (error) {
            console.error(
                "Error fetching admin profile:",
                error
            );

            throw error;
        }
    };